import { render, staticRenderFns } from "./AddLink.vue?vue&type=template&id=1f78819c&"
import script from "./AddLink.vue?vue&type=script&lang=js&"
export * from "./AddLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports